import styled from "styled-components"
import { fieldStyles } from "../styles"

export const StyledField = styled.input`
  ${fieldStyles}

  padding: calc(0.75rem - 1px) 1.25rem;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 0.5rem;
  padding: 1rem;
  font-size: 1rem;

  @supports (-webkit-touch-callout: none) {
    min-height: 3rem;
  }

  &:focus {
    border-color: ${(props) => props.theme.colors.primary};
  }
`
